<template>
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="label pola"
			aria-label="label"
			for="attachment-field-props-label"
			id="attachment-field-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="hint"
			aria-label="hint"
			for="attachment-field-props-hint"
			id="attachment-field-props-hint"
			v-model="fieldProps.hint"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="wzór"
			aria-label="example link"
			for="attachment-field-props-link"
			id="attachment-field-props-link"
			v-model="fieldProps.link"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-checkbox v-model="fieldProps.required" :label="`Wymagane`" aria-label="mandatory"></v-checkbox>
		<v-checkbox v-model="fieldProps.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>
</template>

<script>
	export default {
		name: "attachmentFieldProps",
		props: {
			value: Object,
		},

		methods: {
			removeChip(index) {
				this.chips.splice(index, 1);
			},
			addNewChip(chipName) {
				if (chipName === "" || this.chipWithSameNameExists(chipName)) {
					return;
				}
				this.chips.push({name: this.chipName, model: true});
				this.chipName = "";
			},
			chipWithSameNameExists(name) {
				return this.chips.some(e => e.name === name);
			},
		},

		data() {
			return {
				fieldProps: this.value,
				chips: [],
				chipName: "",
			};
		},

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
			chips: {
				handler() {
					this.fieldProps.options = this.chips.map(chip => chip.name);
				},
			},
		},
	};
</script>

<style scoped>

</style>
